/**
 * @generated SignedSource<<c0e7133f1bca5acf30f4367145e316a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceProductQuery$variables = {
  id: string;
};
export type WorkspaceProductQuery$data = {
  readonly workspaceProduct: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductHeader_ProductDetails">;
  };
};
export type WorkspaceProductQuery = {
  response: WorkspaceProductQuery$data;
  variables: WorkspaceProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceProductQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "WorkspaceProduct",
          "kind": "LinkedField",
          "name": "workspaceProduct",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductHeader_ProductDetails"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WorkspaceProduct",
        "kind": "LinkedField",
        "name": "workspaceProduct",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "type": "ProductDetails",
            "abstractKey": "__isProductDetails"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc8adc715d0f2c5168531fce0fb45260",
    "id": null,
    "metadata": {},
    "name": "WorkspaceProductQuery",
    "operationKind": "query",
    "text": "query WorkspaceProductQuery(\n  $id: ID!\n) {\n  workspaceProduct(id: $id) {\n    ...ProductHeader_ProductDetails\n    id\n  }\n}\n\nfragment ProductHeader_ProductDetails on ProductDetails {\n  __isProductDetails: __typename\n  imageUrl\n  partNumber\n  name\n}\n"
  }
};
})();

(node as any).hash = "7c50c2388104df7ce4ead6bdbc3cbd0b";

export default node;
